import { render, staticRenderFns } from "./ConsentDecisionPanel.vue?vue&type=template&id=cd60d842&scoped=true"
import script from "./ConsentDecisionPanel.vue?vue&type=script&lang=js"
export * from "./ConsentDecisionPanel.vue?vue&type=script&lang=js"
import style0 from "./ConsentDecisionPanel.vue?vue&type=style&index=0&id=cd60d842&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd60d842",
  null
  
)

export default component.exports